import SearchByLocation from './SearchByLocation';
import SearchByUsers from './SearchByUsers';
import SearchByProperties from './SearchByProperties';

export const configFile = [
    {
        tab: 'tab-1',
        tag: 'span',
        title: 'Por ubicación',
        Contents: SearchByLocation,
    },
    {
        tab: 'tab-2',
        tag: 'span',
        title: 'Por usuario',
        Contents: SearchByUsers,
    },
    {
        tab: 'tab-3',
        tag: 'span',
        title: 'Por propiedades',
        Contents: SearchByProperties,
    },
];
